// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "agentsubsystems/v1/agentsubsystems.proto" (package "agentsubsystems.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Agent subsystem configuration RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message agentsubsystems.v1.AgentListSubsystemVersionsRequest
 */
export interface AgentListSubsystemVersionsRequest {
    /**
     * @generated from protobuf field: string platform = 1;
     */
    platform: string;
    /**
     * @generated from protobuf field: string release_channel = 2;
     */
    releaseChannel: string;
}
/**
 * @generated from protobuf message agentsubsystems.v1.AgentSubsystemVersion
 */
export interface AgentSubsystemVersion {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
}
/**
 * @generated from protobuf message agentsubsystems.v1.AgentSubsystemVersions
 */
export interface AgentSubsystemVersions {
    /**
     * @generated from protobuf field: repeated agentsubsystems.v1.AgentSubsystemVersion versions = 1;
     */
    versions: AgentSubsystemVersion[];
}
/**
 * @generated from protobuf message agentsubsystems.v1.AgentListSubsystemVersionsResponse
 */
export interface AgentListSubsystemVersionsResponse {
    /**
     * @generated from protobuf field: map<string, agentsubsystems.v1.AgentSubsystemVersions> subsystems = 1;
     */
    subsystems: {
        [key: string]: AgentSubsystemVersions;
    };
}
/**
 * @generated from protobuf message agentsubsystems.v1.AdminListAllSubsystemVersionsRequest
 */
export interface AdminListAllSubsystemVersionsRequest {
    /**
     * One of: "viam-server", "viam-agent".
     *
     * @generated from protobuf field: string subsystem = 1;
     */
    subsystem: string;
}
/**
 * @generated from protobuf message agentsubsystems.v1.AdminSubsystemVersionInfo
 */
export interface AdminSubsystemVersionInfo {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
    /**
     * @generated from protobuf field: string platform = 2;
     */
    platform: string;
    /**
     * @generated from protobuf field: bool deprecated = 3;
     */
    deprecated: boolean;
    /**
     * @generated from protobuf field: bool is_rc = 4;
     */
    isRc: boolean;
    /**
     * @generated from protobuf field: bool is_dev = 5;
     */
    isDev: boolean;
    /**
     * Release channels (e.g. "stable", "dev") whose tag currently points at this (platform, version).
     *
     * @generated from protobuf field: repeated string release_channels = 6;
     */
    releaseChannels: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deprecated_at = 7;
     */
    deprecatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string deprecated_by = 8;
     */
    deprecatedBy: string;
}
/**
 * @generated from protobuf message agentsubsystems.v1.AdminListAllSubsystemVersionsResponse
 */
export interface AdminListAllSubsystemVersionsResponse {
    /**
     * @generated from protobuf field: repeated agentsubsystems.v1.AdminSubsystemVersionInfo versions = 1;
     */
    versions: AdminSubsystemVersionInfo[];
}
/**
 * @generated from protobuf message agentsubsystems.v1.AdminDeprecateSubsystemVersionRequest
 */
export interface AdminDeprecateSubsystemVersionRequest {
    /**
     * One of: "viam-server", "viam-agent".
     *
     * @generated from protobuf field: string subsystem = 1;
     */
    subsystem: string;
    /**
     * Version to deprecate, without a leading "v". E.g. "999.999.999".
     *
     * @generated from protobuf field: string version = 2;
     */
    version: string;
}
/**
 * @generated from protobuf message agentsubsystems.v1.AdminDeprecateSubsystemVersionResponse
 */
export interface AdminDeprecateSubsystemVersionResponse {
}
/**
 * @generated from protobuf message agentsubsystems.v1.AdminUndeprecateSubsystemVersionRequest
 */
export interface AdminUndeprecateSubsystemVersionRequest {
    /**
     * One of: "viam-server", "viam-agent".
     *
     * @generated from protobuf field: string subsystem = 1;
     */
    subsystem: string;
    /**
     * Version to restore, without a leading "v".
     *
     * @generated from protobuf field: string version = 2;
     */
    version: string;
    /**
     * Also point the version's channel (dev for dev builds, rc for release candidates, stable
     * otherwise) back at it, on every platform the version was published for.
     *
     * @generated from protobuf field: bool promote_to_release_channel = 3;
     */
    promoteToReleaseChannel: boolean;
}
/**
 * @generated from protobuf message agentsubsystems.v1.AdminUndeprecateSubsystemVersionResponse
 */
export interface AdminUndeprecateSubsystemVersionResponse {
}
/**
 * @generated from protobuf message agentsubsystems.v1.GetSubsystemVersionStatusRequest
 */
export interface GetSubsystemVersionStatusRequest {
    /**
     * One of: "viam-server", "viam-agent".
     *
     * @generated from protobuf field: string subsystem = 1;
     */
    subsystem: string;
    /**
     * Version to look up, with or without a leading "v".
     *
     * @generated from protobuf field: string version = 2;
     */
    version: string;
}
/**
 * @generated from protobuf message agentsubsystems.v1.GetSubsystemVersionStatusResponse
 */
export interface GetSubsystemVersionStatusResponse {
    /**
     * @generated from protobuf field: bool deprecated = 1;
     */
    deprecated: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class AgentListSubsystemVersionsRequest$Type extends MessageType<AgentListSubsystemVersionsRequest> {
    constructor() {
        super("agentsubsystems.v1.AgentListSubsystemVersionsRequest", [
            { no: 1, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "release_channel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AgentListSubsystemVersionsRequest
 */
export const AgentListSubsystemVersionsRequest = new AgentListSubsystemVersionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSubsystemVersion$Type extends MessageType<AgentSubsystemVersion> {
    constructor() {
        super("agentsubsystems.v1.AgentSubsystemVersion", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AgentSubsystemVersion
 */
export const AgentSubsystemVersion = new AgentSubsystemVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSubsystemVersions$Type extends MessageType<AgentSubsystemVersions> {
    constructor() {
        super("agentsubsystems.v1.AgentSubsystemVersions", [
            { no: 1, name: "versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AgentSubsystemVersion }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AgentSubsystemVersions
 */
export const AgentSubsystemVersions = new AgentSubsystemVersions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentListSubsystemVersionsResponse$Type extends MessageType<AgentListSubsystemVersionsResponse> {
    constructor() {
        super("agentsubsystems.v1.AgentListSubsystemVersionsResponse", [
            { no: 1, name: "subsystems", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => AgentSubsystemVersions } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AgentListSubsystemVersionsResponse
 */
export const AgentListSubsystemVersionsResponse = new AgentListSubsystemVersionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminListAllSubsystemVersionsRequest$Type extends MessageType<AdminListAllSubsystemVersionsRequest> {
    constructor() {
        super("agentsubsystems.v1.AdminListAllSubsystemVersionsRequest", [
            { no: 1, name: "subsystem", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AdminListAllSubsystemVersionsRequest
 */
export const AdminListAllSubsystemVersionsRequest = new AdminListAllSubsystemVersionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminSubsystemVersionInfo$Type extends MessageType<AdminSubsystemVersionInfo> {
    constructor() {
        super("agentsubsystems.v1.AdminSubsystemVersionInfo", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "deprecated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "is_rc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_dev", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "release_channels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "deprecated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deprecated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AdminSubsystemVersionInfo
 */
export const AdminSubsystemVersionInfo = new AdminSubsystemVersionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminListAllSubsystemVersionsResponse$Type extends MessageType<AdminListAllSubsystemVersionsResponse> {
    constructor() {
        super("agentsubsystems.v1.AdminListAllSubsystemVersionsResponse", [
            { no: 1, name: "versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AdminSubsystemVersionInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AdminListAllSubsystemVersionsResponse
 */
export const AdminListAllSubsystemVersionsResponse = new AdminListAllSubsystemVersionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminDeprecateSubsystemVersionRequest$Type extends MessageType<AdminDeprecateSubsystemVersionRequest> {
    constructor() {
        super("agentsubsystems.v1.AdminDeprecateSubsystemVersionRequest", [
            { no: 1, name: "subsystem", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AdminDeprecateSubsystemVersionRequest
 */
export const AdminDeprecateSubsystemVersionRequest = new AdminDeprecateSubsystemVersionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminDeprecateSubsystemVersionResponse$Type extends MessageType<AdminDeprecateSubsystemVersionResponse> {
    constructor() {
        super("agentsubsystems.v1.AdminDeprecateSubsystemVersionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AdminDeprecateSubsystemVersionResponse
 */
export const AdminDeprecateSubsystemVersionResponse = new AdminDeprecateSubsystemVersionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminUndeprecateSubsystemVersionRequest$Type extends MessageType<AdminUndeprecateSubsystemVersionRequest> {
    constructor() {
        super("agentsubsystems.v1.AdminUndeprecateSubsystemVersionRequest", [
            { no: 1, name: "subsystem", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "promote_to_release_channel", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AdminUndeprecateSubsystemVersionRequest
 */
export const AdminUndeprecateSubsystemVersionRequest = new AdminUndeprecateSubsystemVersionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminUndeprecateSubsystemVersionResponse$Type extends MessageType<AdminUndeprecateSubsystemVersionResponse> {
    constructor() {
        super("agentsubsystems.v1.AdminUndeprecateSubsystemVersionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.AdminUndeprecateSubsystemVersionResponse
 */
export const AdminUndeprecateSubsystemVersionResponse = new AdminUndeprecateSubsystemVersionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSubsystemVersionStatusRequest$Type extends MessageType<GetSubsystemVersionStatusRequest> {
    constructor() {
        super("agentsubsystems.v1.GetSubsystemVersionStatusRequest", [
            { no: 1, name: "subsystem", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.GetSubsystemVersionStatusRequest
 */
export const GetSubsystemVersionStatusRequest = new GetSubsystemVersionStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSubsystemVersionStatusResponse$Type extends MessageType<GetSubsystemVersionStatusResponse> {
    constructor() {
        super("agentsubsystems.v1.GetSubsystemVersionStatusResponse", [
            { no: 1, name: "deprecated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message agentsubsystems.v1.GetSubsystemVersionStatusResponse
 */
export const GetSubsystemVersionStatusResponse = new GetSubsystemVersionStatusResponse$Type();
/**
 * @generated ServiceType for protobuf service agentsubsystems.v1.AgentSubsystemsService
 */
export const AgentSubsystemsService = new ServiceType("agentsubsystems.v1.AgentSubsystemsService", [
    { name: "AgentListSubsystemVersions", options: {}, I: AgentListSubsystemVersionsRequest, O: AgentListSubsystemVersionsResponse },
    { name: "AdminListAllSubsystemVersions", options: {}, I: AdminListAllSubsystemVersionsRequest, O: AdminListAllSubsystemVersionsResponse },
    { name: "AdminDeprecateSubsystemVersion", options: {}, I: AdminDeprecateSubsystemVersionRequest, O: AdminDeprecateSubsystemVersionResponse },
    { name: "AdminUndeprecateSubsystemVersion", options: {}, I: AdminUndeprecateSubsystemVersionRequest, O: AdminUndeprecateSubsystemVersionResponse },
    { name: "GetSubsystemVersionStatus", options: {}, I: GetSubsystemVersionStatusRequest, O: GetSubsystemVersionStatusResponse }
]);
